// Eight product lines for Vegan Danish Bakery Foods
// Sourced directly from official sell sheets / PDFs.
export const PRODUCTS = [
  {
    slug: 'pastry-collection',
    name: 'Vegan Danish Pastry Collection',
    tagline: 'Indulgence with Purpose',
    category: 'Pastries',
    color: 'green',
    image: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/5dqnirxr_Vegan_Danish_Pastry_Catalog.png',
    secondaryImage: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/ca0sql9e_Danish.png',
    short: 'Six signature danishes and three filled croissants — 100% plant-based, unforgettable flavor.',
    long: 'Our flagship pastry catalog: six signature Danishes (Cherry, Blueberry, Lemon, Chocolate, Almond, Raspberry) and three filled croissants (Boston Cream, Almond Custard, Éclair Cream). 100% plant-based. Delivered Thaw & Serve or Frozen Ready-to-Bake — your back-of-house picks the workflow.',
    pdf: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/f8xxe6by_Vegan_Danish_Pastry_Catalog_8.5x11.pdf',
    variants: ['Cherry Danish', 'Blueberry Danish', 'Lemon Danish', 'Chocolate Danish', 'Almond Danish', 'Raspberry Danish', 'Boston Cream Croissant', 'Almond Custard Croissant', 'Éclair Cream Croissant'],
    format: 'Thaw & Serve · Frozen Ready-to-Bake',
    unitCase: '24 ct mixed',
    weight: '85–110 g',
    shelfLife: '180 days frozen',
    highlights: [
      '100% plant-based, dairy & egg free',
      'Two formats: Thaw & Serve or Bake-from-Frozen',
      'Beautiful presentation — photographs as well as it bakes',
      'Built for universities, hotels, restaurants and caterers'
    ],
    certs: ['Plant-Based', 'Vegan', 'Non-GMO'],
    pairings: ['Oat-milk latte', 'Drip coffee', 'Earl Grey tea']
  },
  {
    slug: 'breakfast-grab-and-go',
    name: 'Breakfast Grab & Go Sandwiches',
    tagline: 'Plant-based breakfast. Made easy.',
    category: 'Sandwiches',
    color: 'sage',
    image: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/qc47pguj_Vegan_Danish_Breakfast_Grab.png',
    secondaryImage: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/06nmlr1f_croissants2.png',
    short: 'Three pre-built grab-and-go breakfast sandwiches — sustainable, satisfying, delicious every time.',
    long: 'Three SKUs engineered for the morning rush: Plant-Based Ham & Cheese Croissant (156 g), Plant-Based Ham & Cheese Melt on gluten-free bread (142 g), and Plant-Based Egg Salad Sandwich on gluten-free bread (136 g). Pre-built, individually wrapped, ready for your case.',
    pdf: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/ljkhgl0k_Vegan_Danish_Breakfast_Grab_and_Go_Ad.pdf',
    variants: ['Ham & Cheese Croissant — 156 g', 'Ham & Cheese Melt on GF Bread — 142 g', 'Egg Salad Sandwich on GF Bread — 136 g'],
    format: 'Refrigerated grab-and-go',
    unitCase: '12 ct',
    weight: '136–156 g',
    shelfLife: '14 days refrigerated',
    highlights: [
      '100% plant-based — dairy & egg free',
      'Gluten-free bread options available',
      'Pre-built, individually wrapped',
      'Ideal for university dining & hotel grab-and-go'
    ],
    certs: ['Plant-Based', 'Vegan', 'GF Options'],
    pairings: ['Cold brew', 'Oat-milk cappuccino', 'Fresh-pressed juice']
  },
  {
    slug: 'happy-eats-bagels',
    name: 'Happy Eats Bagel Kit',
    tagline: 'Good Food. Good Morning. Happy You.',
    category: 'Bagels',
    color: 'honey',
    image: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/sza76mne_Happy_Eats_Bagel.png',
    secondaryImage: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/2gicgvw7_bagel.png',
    short: 'A plain bagel, Daiya plant-based cream cheese, and a wooden spreader — one happy little kit.',
    long: 'Our sub-brand for the morning crowd. Each Happy Eats kit ships a soft plain bagel, a portion of Daiya cultured plant-based cream cheese and a wooden spreader — all in one tidy package. Also available pre-assembled as a Cream Cheese Bagel and a Gluten-Free Cream Cheese Bagel.',
    pdf: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/pyjtlxbz_Happy_Eats_Bagel_Ad_8.5x11.pdf',
    variants: ['Bagel Kit (bagel + Daiya cream cheese + spreader)', 'Cream Cheese Bagel (pre-assembled)', 'Gluten-Free Cream Cheese Bagel'],
    format: 'Refrigerated / Frozen · Thaw fully & serve',
    unitCase: '18 ct',
    weight: '120 g kit',
    shelfLife: '30 days refrigerated · 120 days frozen',
    highlights: [
      'Co-branded with Daiya plant-based cream cheese',
      'Gluten-free SKU available',
      'Single-pack ready-to-serve',
      'Made for your moments — anytime, anywhere'
    ],
    certs: ['Plant-Based', 'Vegan', 'Dairy-Free', 'Gluten-Free Option'],
    pairings: ['Hot coffee', 'Fresh fruit cup', 'Cold-pressed OJ']
  },
  {
    slug: 'egg-patties',
    name: 'Plant-Based Egg Patties & Sandwiches',
    tagline: 'Chef Inspired. Student Approved.',
    category: 'Egg Patties',
    color: 'amber',
    image: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/j5n20xru_Vegan_Danish_Egg_Patty.png',
    secondaryImage: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/bc9ibtci_VeganBreakfastSandwichBacon2.png',
    short: 'Premium plant-based egg patties and four pre-built breakfast sandwiches. Ready in minutes.',
    long: 'Individually quick-frozen plant-based egg patties with a fluffy texture and beautiful golden color — consistent every time. Available as a 60-count case for build-your-own programs or as four pre-built sandwiches: Bacon & Cheddar, Sausage & Cheddar, Ham & Cheddar, and Mushroom Melt Swiss.',
    pdf: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/s198o2cv_Vegan_Danish_Egg_Patty_Sell_Sheet_Printable_8.5x11%20%281%29.pdf',
    variants: ['Egg Patty (IQF, build-your-own)', 'Bacon & Cheddar Sandwich', 'Sausage & Cheddar Sandwich', 'Ham & Cheddar Sandwich', 'Mushroom Melt Swiss Sandwich'],
    format: 'Individually quick-frozen · Heat & serve',
    unitCase: '60 ct patties / 24 ct sandwiches',
    weight: '62 g patty',
    shelfLife: '270 days frozen',
    highlights: [
      '100% plant-based, cholesterol-free, non-GMO',
      'No artificial flavors, no preservatives',
      'Kosher Friendly & Halal Friendly',
      'Build-your-own or ready-made sandwich — you choose'
    ],
    certs: ['Plant-Based', 'Kosher Friendly', 'Halal Friendly', 'Non-GMO'],
    pairings: ['Avocado & fresh tomato', 'Sautéed mushrooms', 'Hash browns']
  },
  {
    slug: 'comfort-snacks',
    name: 'Comfort Foods & Snacks',
    tagline: 'Grab. Go. Enjoy.',
    category: 'Snacks',
    color: 'rose',
    image: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/erqmji59_Vegan_Danish_Comfort_Foods_Snacks.png',
    secondaryImage: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/qhxebihs_45302108_342773389852211_6962917237002862592_n.jpg',
    short: 'Eight individually packaged plant-based comfort items — perfect for campus and on the go.',
    long: 'A curated line of single-serve plant-based comfort foods: classic donut, pecan butter tart, layered cake parfait, cheesecake cup, danish pastry, frosted cupcake, birthday cake slice and donut bites tub. Bright, photogenic, individually packaged — made to satisfy cravings between classes, shifts and meetings.',
    pdf: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/bpzuh0ww_Vegan_Danish_Comfort_Foods_Snacks_8.5x11.pdf',
    variants: ['Donut', 'Pecan Butter Tart', 'Cake Parfait', 'Cheesecake Cup', 'Danish Pastry', 'Cupcake', 'Birthday Cake', 'Donut Bites Tub'],
    format: 'Individually packaged · Ambient or refrigerated',
    unitCase: '24 ct mixed',
    weight: '60–130 g',
    shelfLife: '21 days ambient',
    highlights: [
      'Eight crowd-pleasing SKUs in one program',
      'Individually packaged for grab-and-go',
      'Made with fresh ingredients, with care',
      'Built for campus life, hotel pantries & impulse zones'
    ],
    certs: ['Plant-Based', 'Vegan'],
    pairings: ['Drip coffee', 'Iced matcha', 'Chocolate oat-milk']
  },
  {
    slug: 'mac-and-cheese',
    name: 'Pure Mac & Cheese',
    tagline: 'Indulge in Every Bite!',
    category: 'Comfort Meals',
    color: 'cheddar',
    image: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/15vlc5gj_Vegan_Danish_Mac_Cheese_Lunch_Dinner.png',
    secondaryImage: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/emfnb4mm_macNcheese.png',
    short: 'Creamy, cheesy, oh-so-satisfying plant-based mac — lunch or dinner portion.',
    long: 'Pure comfort food made with wholesome plant-based ingredients. Available in two formats: a 226 g Lunch Size single-serve and a 454 g Dinner Size portion. Sealed in a foil tray for oven or microwave — bake covered 45 minutes from frozen at 175°C, or microwave 2–3 minutes once thawed.',
    pdf: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/ex8iw38n_Vegan_Danish_Mac_Cheese_Lunch_Dinner_8.5x11.pdf',
    variants: ['Lunch Size — 226 g', 'Dinner Size — 454 g'],
    format: 'Frozen · Bake from frozen / Microwave once thawed',
    unitCase: '12 ct',
    weight: '226 g / 454 g',
    shelfLife: '270 days frozen',
    highlights: [
      '100% plant-based · Gluten-free · Dairy-free',
      'Oven or microwave — your call',
      'Two portion sizes for any daypart',
      'Sealed foil tray — stack, store, serve'
    ],
    certs: ['Plant-Based', 'Vegan', 'Gluten-Free', 'Dairy-Free'],
    pairings: ['Movie night', 'Late-night snack', 'Side of garlic bread']
  },
  {
    slug: 'mac-and-sausage',
    name: 'Mac & Cheese with Savory Sausage',
    tagline: 'Pure Comfort. Indulge in Every Bite.',
    category: 'Comfort Meals',
    color: 'cocoa',
    image: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/hu3uhvn3_Vegan_Danish_Mac_and_Cheese.png',
    secondaryImage: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/oji88vlp_macNcheeses-sausage.png',
    short: 'Mac & cheese loaded with plant-based savory sausage crumbles — cozy and hearty.',
    long: 'Creamy plant-based mac & cheese folded with our seasoned savory plant sausage crumbles. Warm, cheesy and ready when you are. Bake covered 45 min at 175°C from frozen, or microwave 2–3 minutes once thawed.',
    pdf: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/q8p7x78f_Vegan_Danish_Mac_and_Cheese_8.5x11.pdf',
    variants: ['Single-serve foil tray — 340 g'],
    format: 'Frozen · Bake or microwave',
    unitCase: '12 ct',
    weight: '340 g',
    shelfLife: '270 days frozen',
    highlights: [
      '100% plant-based, gluten-free, dairy-free',
      'Loaded with plant-based sausage crumbles',
      'Perfect for movie nights and late nights',
      'Sealed foil tray — ready when you are'
    ],
    certs: ['Plant-Based', 'Vegan', 'Gluten-Free', 'Dairy-Free'],
    pairings: ['Crusty bread', 'Side salad', 'Sparkling water']
  },
  {
    slug: 'gluten-free-lasagna',
    name: 'Gluten-Free Plant-Based Lasagna',
    tagline: 'Enjoy Delicious Comfort Anywhere',
    category: 'Comfort Meals',
    color: 'tomato',
    image: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/dgsx38md_Vegan_Danish_Gluten_Free_Lasagna.png',
    secondaryImage: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/28ooju9h_Lasagna.png',
    short: 'Creamy plant cheese and Italian herb tomato sauce, layered into a gluten-free lasagna.',
    long: 'A comfort classic reimagined. Layers of gluten-free pasta, our creamy plant-based cheese and a slow-simmered Italian herb tomato sauce — baked, blast-frozen and sealed in a foil pan. Heat from frozen or thawed; ready in the oven or microwave.',
    pdf: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/88on4k8j_Vegan_Danish_Gluten_Free_Lasagna_8.5x11.pdf',
    variants: ['Single-serve foil tray — 340 g', 'Family tray — 907 g'],
    format: 'Frozen · Bake or microwave',
    unitCase: '12 ct single / 6 ct family',
    weight: '340 g / 907 g',
    shelfLife: '270 days frozen',
    highlights: [
      '100% plant-based & gluten-free',
      'Creamy plant cheese, real Italian herbs',
      'Two pack sizes for any operator',
      'Cook from frozen — zero scratch prep'
    ],
    certs: ['Plant-Based', 'Vegan', 'Gluten-Free', 'Dairy-Free'],
    pairings: ['Crisp green salad', 'Garlic toast', 'Sparkling water']
  }
];

export const getProduct = (slug) => PRODUCTS.find(p => p.slug === slug);
